//Name: Artist Type
//CODE: AType
//Age: ''
//Gender: Both
const artistTypeOptions = [
  { id: '0', value: "Actor", label: "Actor" },
  { id: '1', value: "Business Professional", label: "Business Professional" },
  { id: '2', value: "Child Talent", label: "Child Talent" },
  { id: '3', value: "Circus Performer", label: "Circus Performer" },
  { id: '4', value: "Comedian", label: "Comedian" },
  { id: '5', value: "Commercial", label: "Commercial" },
  { id: '6', value: "Crew", label: "Crew" },
  { id: '7', value: "Dancer", label: "Dancer" },
  { id: '8', value: "Extra", label: "Extra" },
  { id: '9', value: "Influencer", label: "Influencer" },
  { id: '10', value: "Make-up Artist", label: "Make-up Artist" },
  { id: '11', value: "MC", label: "MC" },
  { id: '12', value: "Model", label: "Model" },
  { id: '13', value: "Musician", label: "Musician" },
  { id: '15', value: "Photographer", label: "Photographer" },
  { id: '16', value: "Presenter", label: "Presenter" },
  { id: '17', value: "Singer", label: "Singer" },
  { id: '18', value: "Student", label: "Student" },
  { id: '19', value: "Stunt Performer", label: "Stunt Performer" },
  { id: '20', value: "Stylist", label: "Stylist" },
  { id: '21', value: "Variety Performer", label: "Variety Performer" },
  { id: '22', value: "Voice Artist", label: "Voice Artist" },
  { id: '14', value: "Other", label: "Other" }
];  

export default artistTypeOptions;


// WEBPACK FOOTER //
// ./src/data/artist-type.js